import { atom, useRecoilState, useResetRecoilState } from "recoil";

interface DispatchProps {
  text?: string;
  func: () => void | boolean;
  duration?: number; //sec
  onConfirm?: () => void;
  onCancel?: () => void;
}

const warningModalPropsAtom = atom<
  DispatchProps & {
    show: boolean;
  }
>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  default: {
    text: "Dilarang Menyebarkan Data Perusahaan ke Luar Ekosistem Erdigma",
    duration: 5,
    func: () => {
      console.log("false");
    },
    show: false,
  },
  key: "warningModalPropsAtom",
});

export const useWarningModal = () => {
  const [props, setProps] = useRecoilState(warningModalPropsAtom);
  const reset = useResetRecoilState(warningModalPropsAtom);

  function dispatchWarning(options: DispatchProps) {
    Promise.resolve(
      setProps((prev) => ({
        ...prev,
        ...options,
        show: true,
      }))
    );
  }

  function getDispacthedProps() {
    return props;
  }

  function closeWarning() {
    reset();
  }

  function isModalOpen() {
    return props.show;
  }

  function toggleModal() {
    setProps((prev) => ({ ...prev, show: !prev }));
  }

  return {
    dispatchWarning,
    getDispacthedProps,
    closeWarning,
    isModalOpen,
    toggleModal,
  };
};
